import 'core-js/stable';
// optional but required for transforming generator fns.
import 'regenerator-runtime/runtime';
import 'element-ui/lib/theme-chalk/index.css';
import Vue from "vue"
import App from "./App.vue"
import { store } from "./store/store";
import router from "./routes";
import lodash from 'lodash';
import moment from "moment";
import "moment-timezone";
import { rest } from "@/utilities";
import globalComponents from "./globalComponents";

Vue.use(globalComponents);

Vue.prototype.$moment = moment;
Vue.prototype.$rest = rest;
Vue.prototype._ = lodash;
window._ = require('lodash');

Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});

(function (global, app) {

  
  app.vm = new Vue({
    el: `#${global.bits.modules.signup.appId}`,
    store:store,
    router: router,
    render: h => h(App)
  });

}(window, window.bits.modules.signup));



